import './progress_bar.scss';
import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '..';
import { STROKE_COLORS } from './Constants';
const ProgressBar = _ref => {
  let {
    animationTime,
    circle,
    className,
    defaultTheme,
    getSelectedPosition,
    image,
    imgHeight,
    lineSize,
    secondValue,
    size,
    strokeWidth,
    tooltipTitle,
    value
  } = _ref;
  const {
    theme
  } = useTheme();
  const componentTheme = defaultTheme || theme;
  const [progress, setProgress] = useState(0);
  const progressRef = useRef();
  useEffect(() => {
    if (!circle) return;
    setProgress(value);
  }, [value]);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const dash = progress * circumference / 100;
  const handleClick = e => {
    const progressBar = progressRef.current;
    if (progressBar) {
      const clickedPosition = e.clientX - progressBar.getBoundingClientRect().left;
      const progressBarWidth = progressBar.offsetWidth;
      const clickedPercentage = clickedPosition / progressBarWidth * 100;
      getSelectedPosition(clickedPercentage.toFixed(2));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, circle ? /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-progress-circle', {
      'with-image': image
    }, componentTheme),
    style: image && {
      minWidth: size,
      height: size
    }
  }, image && /*#__PURE__*/React.createElement("img", {
    className: "wrts-progress-image",
    src: image,
    alt: "image",
    style: {
      height: imgHeight
    }
  }), /*#__PURE__*/React.createElement("svg", {
    className: "wrts-progress-line",
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: STROKE_COLORS[componentTheme],
    cx: size / 2,
    cy: size / 2,
    r: radius,
    strokeWidth: `${strokeWidth}px`
  }), /*#__PURE__*/React.createElement("circle", {
    className: "wrts-progress-stroke",
    fill: "none",
    stroke: STROKE_COLORS.green,
    cx: size / 2,
    cy: size / 2,
    r: radius,
    strokeWidth: `${strokeWidth}px`,
    transform: `rotate(-90 ${size / 2} ${size / 2})`,
    strokeDasharray: [dash, circumference - dash],
    strokeLinecap: "round"
  }))) : /*#__PURE__*/React.createElement("div", {
    ref: progressRef,
    className: classNames('wrts-progress-bar', lineSize, className, componentTheme, {
      'cursor-pointer': getSelectedPosition
    }),
    onClick: getSelectedPosition ? handleClick : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "wrts-progress transparent",
    style: {
      width: `${secondValue || 0}%`
    },
    "data-tooltip-id": "progress",
    "data-tooltip-content": tooltipTitle
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames('wrts-progress', {
      'with-animation': animationTime
    }),
    style: animationTime ? {
      width: `${value}%`,
      animationDuration: `${animationTime}s`
    } : {
      width: `${value || 0}%`
    }
  })));
};
ProgressBar.propTypes = {
  animationTime: PropTypes.number,
  circle: PropTypes.bool,
  className: PropTypes.string,
  image: PropTypes.string,
  imgHeight: PropTypes.number,
  secondValue: PropTypes.number,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  tooltipTitle: PropTypes.string,
  value: PropTypes.number,
  lineSize: PropTypes.oneOf(['medium', 'small'])
};
ProgressBar.defaultProps = {
  circle: false,
  size: 24,
  strokeWidth: 4,
  imgHeight: 80
};
export default /*#__PURE__*/memo(ProgressBar);